export default "__VITE_ASSET__qShOhGK8__"